<template>
    <van-popup
        v-model="show"
        closeable
        position="bottom"
        :style="{ height: '30%' }">
        <van-field
            style="margin-top:3rem"
            v-model="value"
            :label="labeltxt"
            :placeholder="placeholdertxt"
        />
        <div style="margin: 16px;">
            <van-button round block type="info" @click="save()">保存</van-button>
        </div>
    </van-popup>
</template>

<script>
import { 
    Popup, Field, Button
} from 'vant'
import { VipInfoApi } from '@/api/vip'

export default {
    components: {
        [Popup.name]: Popup,
        [Field.name]: Field,
        [Button.name]: Button,
    },
    props: ['title', 'labeltxt', 'placeholdertxt'],
    data() {
        return {
            show: false,
            value: '',
            from:{
                name: null,
                address: null
            },
        }
    },
    methods: {
        save(){
            if(this.value!=null&&this.value!=''&&this.value!=this.vipval){
                var that = this
                if(that.title==='name'){
                    that.from.name = that.value
                }else if(that.title==='address'){
                    that.from.address = that.value
                }
                that.axios.post(VipInfoApi, that.from).then((ret) => {
                    console.log(ret)
                    if(ret.flag){
                        that.show = false
                        that.value = null
                        that.$parent.getVipInfo()
                    }
                }).catch((ex) => {
                    console.log(ex)
                })
            }
            that.show = false
        },
        showdig(val){
            this.value = val
            this.show = true
        }
    }
}
</script>